import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.div`
  position: relative;
  display: inline-flex;
  text-align: center;
  width: 100%;

  .masonry-asset-grid {
    display: flex;
    width: 100%;
    gap: ${({ theme }) => rem(theme.Grid.Spacing)};
  }
  .masonry-asset-grid-column {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => rem(theme.Grid.Spacing)};
    background-clip: padding-box;
  }
`;

interface StyledDroppableAreaProps {
  isVisible: boolean;
}

export const StyledDroppableArea = styled.div<StyledDroppableAreaProps>`
  position: fixed;
  display: ${({ isVisible }) => (isVisible ? 'inline-flex' : 'none')};
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
`;

export const StyledCardPlaceholder = styled.div`
  display: flex;
  width: 100%;
  height: auto;

  .ant-skeleton {
    min-width: 100% !important;
    width: 100% !important;
  }
`;
